import styled, { css } from 'styled-components'

type Props = {
	size?: number
	shouldOverlapCard?: boolean
}

export const Wrapper = styled.div<Props>`
	display: flex;
	justify-content: space-around;
	height: ${({ size = 256 }) => size}px;
	width: ${({ size = 256 }) => size}px;

	${({ shouldOverlapCard = false }) =>
		shouldOverlapCard &&
		css<Props>`
		position: absolute;
		top: -${({ size = 256 }) => size / 2}px;
		height: ${({ size = 256 }) => size}px;
		width: ${({ size = 256 }) => size}px;
	`}
`
